import ProductRegisterContainer from './ProductRegisterContainer';
export default ProductRegisterContainer;
